import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Box, Button, Divider, Stack, Typography, useTheme } from '@mui/material';

import { TalentBasicInfoFields } from '@/views/TalentEditInfoModal/BasicInfo';
import { TalentBasicInfoViewType } from '@/views/TalentEditInfoModal/constants';

const TalentBasicInfoView = ({ onSubmit }: { onSubmit(): void }) => {
  const { handleSubmit } = useFormContext();
  const { t } = useTranslation();
  const { spacing, palette } = useTheme();

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}
    >
      <Box flexBasis={0} flexGrow={1} overflow="auto">
        <Typography component="h2" variant="body1Bold" sx={{ padding: 3 }}>
          {t('talents:layouts.talentEditModal.tabs.basicInfo')}
        </Typography>
        <TalentBasicInfoFields
          viewType={TalentBasicInfoViewType.CREATE}
          sx={({ spacing }) => ({
            padding: spacing(0, 3, 3)
          })}
        />
      </Box>
      <Divider sx={{ marginTop: 'auto', borderColor: palette.grey[400] }} />
      <Stack direction="row" sx={{ padding: spacing(2.5, 2, 2), gap: spacing(1.5), justifyContent: 'space-between' }}>
        <Button disabled>{t('common:actions.back')}</Button>
        <Button type="submit" color="primary" variant="contained">
          {t('common:actions.next')}
        </Button>
      </Stack>
    </Box>
  );
};

export default TalentBasicInfoView;
